export default {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#fff",
    borderColor: state.isFocused ? "#07145a !important" : "#ebecf0",
    borderRadius: "3px",
    borderWidth: "1px",
    minHeight: "28px",
    minWidth: "120px",
    maxWidth: "360px",
    fontSize: "14px",
    boxShadow: null,
  }),
  menu: (provided) => ({
    ...provided,
    textAlign: "left",
    minWidth: "120px",
    maxWidth: "360px",
    fontSize: "14px",
    color: "#07145a",
    zIndex: "9999",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "var(--ds-background-brand, #07145a1c)"
      : state.isFocused && "#f1f2f3",
    color: state.isSelected && "var(--ds-text-brand, #07145a);",
    boxShadow: state.isFocused ? "inset 1px 0px 0px var(--ds-text-brand, #07145a);" : "",
  }),
  valueContainer: (provided) => ({
    ...provided,
    top: "-6%",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
  }),
  placeholder: (provided) => ({
    ...provided,
    top: "46%",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "28px",
  }),
};
